import Vue from 'vue'
import VueRouter from 'vue-router'

import routes from './routes'

Vue.use(VueRouter)

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation
 */

export default function (/* { store, ssrContext } */) {
	const Router = new VueRouter({
		scrollBehavior: () => ({ y: 0 }),
		routes,

		// Leave these as is and change from quasar.conf.js instead!
		// quasar.conf.js -> build -> vueRouterMode
		mode: process.env.VUE_ROUTER_MODE,
		base: process.env.VUE_ROUTER_BASE
	})

	// Router.beforeEach((to, from, next) => {
	// 	console.log(to, from)
	// 	console.log(from.query.hasOwnProperty('redirect'))
	// 	if (from.query.hasOwnProperty('redirect')) {
	// 		console.log('aqui')
	// 		// next({ query: { redirect: from.query.redirect } })
	// 		next({ path: to.path, query: {redirect: from.query.redirect}})
	// 	}
	// 	else {
	// 		next()
	// 	}
	// })
	

	return Router
}
